var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", size: "mini", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "101323",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SequenceNumber") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "unitId", disabled: true },
                        model: {
                          value: _vm.editDialog.form.unitId,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "unitId", $$v)
                          },
                          expression: "editDialog.form.unitId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Code") } },
                    [
                      _c("el-input", {
                        attrs: { no: "code" },
                        model: {
                          value: _vm.editDialog.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "code", $$v)
                          },
                          expression: "editDialog.form.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ChineseName") } },
                    [
                      _c("el-input", {
                        attrs: { no: "chineseName" },
                        model: {
                          value: _vm.editDialog.form.chineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "chineseName", $$v)
                          },
                          expression: "editDialog.form.chineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_EnglishName") } },
                    [
                      _c("el-input", {
                        attrs: { no: "englishName" },
                        model: {
                          value: _vm.editDialog.form.englishName,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "englishName", $$v)
                          },
                          expression: "editDialog.form.englishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_DefaultOrNot") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "ifDefault" },
                          on: { change: _vm.onDefaultChange },
                          model: {
                            value: _vm.editDialog.form.ifDefault,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "ifDefault", $$v)
                            },
                            expression: "editDialog.form.ifDefault"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { float: "left" },
                              attrs: { label: true }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { float: "left" },
                              attrs: { label: false }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Information.BusinessType") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "seaFreight" },
                          model: {
                            value: _vm.editDialog.form.seaFreight,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "seaFreight", $$v)
                            },
                            expression: "editDialog.form.seaFreight"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OceanFreight")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "airFreight" },
                          model: {
                            value: _vm.editDialog.form.airFreight,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "airFreight", $$v)
                            },
                            expression: "editDialog.form.airFreight"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Air")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "fbaSea" },
                          model: {
                            value: _vm.editDialog.form.fbaSea,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "fbaSea", $$v)
                            },
                            expression: "editDialog.form.fbaSea"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FbaSea")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "fbaAir" },
                          model: {
                            value: _vm.editDialog.form.fbaAir,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "fbaAir", $$v)
                            },
                            expression: "editDialog.form.fbaAir"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FbaAir")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "fbaRailway" },
                          model: {
                            value: _vm.editDialog.form.fbaRailway,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "fbaRailway", $$v)
                            },
                            expression: "editDialog.form.fbaRailway"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FbaRailway")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "chargeUnit" },
                          model: {
                            value: _vm.editDialog.form.chargeUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "chargeUnit", $$v)
                            },
                            expression: "editDialog.form.chargeUnit"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.MeasureCurrency")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "unit" },
                          model: {
                            value: _vm.editDialog.form.unit,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "unit", $$v)
                            },
                            expression: "editDialog.form.unit"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Unit")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "unit" },
                          on: { change: _vm.specifyBoxTypeChange },
                          model: {
                            value: _vm.editDialog.form.specifyBoxType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "specifyBoxType",
                                $$v
                              )
                            },
                            expression: "editDialog.form.specifyBoxType"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BoxType2")))]
                      )
                    ],
                    1
                  ),
                  _vm.editDialog.form.specifyBoxType
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_BoxTypeAndCategory")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { width: "200px", display: "flex" }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "eqSize",
                                  "select-type":
                                    _vm.selectTypeNames.local_cache_EQSize3,
                                  fields: ["code"],
                                  filterable: "",
                                  placeholder: " ",
                                  "show-copy": false,
                                  "default-value": _vm.editDialog.form.eqSize,
                                  "tag-name": "code"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.eqSize = p.value
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "eqType",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_EQType,
                                  fields: ["code"],
                                  filterable: "",
                                  placeholder: " ",
                                  "show-copy": false,
                                  "default-value": _vm.editDialog.form.eqType,
                                  "tag-name": "code"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.editDialog.form.eqType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "remake",
                          placeholder: _vm.$t("CargoMsg.Cargo_RuleNotesTip"),
                          type: "textarea",
                          row: 2
                        },
                        model: {
                          value: _vm.editDialog.form.remake,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remake", $$v)
                          },
                          expression: "editDialog.form.remake"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }